import {AfterViewInit, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar} from '@angular/material';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {FourDService} from '4d-mapper';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {FileManagementService} from '../../../../service/file-manager.service';
import {AppService} from '../../../../commons/app.service';
import {MapService} from '../../../../commons/map.service';
import {TranslateService} from '@ngx-translate/core';
import {AppBaseComponent} from '../../../../commons/AppBaseComponent';

import { StripeService, Elements, Element as StripeElement, ElementsOptions } from "ngx-stripe";
import {Address} from 'ngx-stripe/lib/interfaces/utils';
import { XsApplicationEventsService } from '../../../../xs/services/events/application-events.service';

declare const payments: any;
@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss']
})
export class PaymentComponent extends AppBaseComponent implements OnInit, OnDestroy {

  elements: Elements;
  card: StripeElement;

  // optional parameters
  elementsOptions: ElementsOptions = {
    locale: 'auto'
  };

  stripeTest: FormGroup;

  constructor(private fourD: FourDService, public service: AppService, private r: Router, sn: MatSnackBar, d: MatDialog, private ar: ActivatedRoute, private t: TranslateService, private trans: TranslateService
    , private fb: FormBuilder, private cd: ChangeDetectorRef, private fileManager: FileManagementService, public dialogRef: MatDialogRef<PaymentComponent>, public snackBar: MatSnackBar,
              private mapService: MapService, @Inject(MAT_DIALOG_DATA) public data, private httpClient: HttpClient,
              private stripeService: StripeService, applicationEvents:XsApplicationEventsService
              // private stripeFactory: StripeFactoryService
  ) {
    super(service, r, sn, d, applicationEvents);
  }

  init() {
    this.stripeTest = this.fb.group({
      name: ['', [Validators.required]]
    });
    // this.stripe = this.stripeFactory.create('pk_test_PEfNqLj0cgu6mRflQPo81oVq');
    //this.stripeService.setKey('pk_test_PEfNqLj0cgu6mRflQPo81oVq');

    // const Stripe$: Observable<any> = this.stripeService.getStripeReference();

    // this is a reference to the stripe elements object
    // const stripe = this.stripeService.getInstance();

    this.stripeService.elements(this.elementsOptions)
      .subscribe(elements => {
        this.elements = elements;
        // Only mount the element the first time
        if (!this.card) {
          this.card = this.elements.create('card', {
            style: {
              base: {
                iconColor: '#666EE8',
                color: '#31325F',
                lineHeight: '40px',
                fontWeight: 300,
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontSize: '18px',
                '::placeholder': {
                  color: '#CFD7E0'
                }
              }
            }
          });
          this.card.mount('#card-element');
        }
      });
  }

  buy() {
    const name = this.stripeTest.get('name').value;
    this.stripeService
      .createToken(this.card, { name })
      .subscribe(result => {
        if (result.token) {
          // Use the token to create a charge or a customer
          // https://stripe.com/docs/charges
          console.log(result.token);
        } else if (result.error) {
          // Error creating the token
          console.log(result.error.message);
        }
      });
  }

  buyPlan() {
    const name = this.stripeTest.get('name').value;
    var ownerInfo = {
      owner: {
        email: 'haresh.aprajapati@4dmapper.com',
        name: 'haresh',
        phone: 'haresh',
        address: {
          city: 'Berlin',
          line1: 'Nollendorfstraße 27',
          postal_code: '10777',
          country: 'DE',
          line2: '',
          state: ''
        }
  },
    };
    this.stripeService
      .createSource(this.card, ownerInfo)
      .subscribe(result => {
        if (result.source) {
          // Use the token to create a charge or a customer
          // https://stripe.com/docs/charges
          console.log(result.source);
        } else if (result.error) {
          // Error creating the token
          console.log(result.error.message);
        }
      });
  }

  submit(){
    return;
  }
  payment(){
    /*
    var Simplify = require("simplify-commerce");
   var client = Simplify.getClient({
      publicKey: 'sbpb_ZTAzODAyNzEtYzhjNi00NDQ1LTg3NGEtMjgzMWY3OTU0ZWYx',
      privateKey: 'vtXprAoMAphNZOHZdlAXCmjjyG4qveV+ZUDCHLRo3oh5YFFQL0ODSXAOkNtXTToq'
    });

    client.cardtoken.create({
      card : {
        addressState : "MO",
        expMonth : "11",
        expYear : "19",
        addressCity : "OFallon",
        cvc : "123",
        number : "5105105105105100"
      }
    }, function(errData, data){

      if(errData){
        console.error("Error Message: " + errData.data.error.message);
        // handle the error
        return;
      }

      console.log("Success Response: " + JSON.stringify(data));
    });*/
  }
}
